<template>
  <v-card tabindex="-1" @keydown.esc="$emit('close')" @keydown.enter="$emit('enter')">
    <v-layout column>
      <v-toolbar card dense light flat>
      <v-toolbar-title>
        <v-flex>
          <v-layout row>
            <v-toolbar-title v-if="getIsMobile">Выберите</v-toolbar-title>
            <v-toolbar-title v-if="!getIsMobile">{{title}}</v-toolbar-title>
          </v-layout>
        </v-flex>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-actions-btn :caption="sourceActionsCaption()" :actions="sourceActions()"></v-actions-btn>
      <v-btn icon @click="cancel">
        <v-icon>close</v-icon>
      </v-btn>
      </v-toolbar>
    <div v-if="sourceIs('FAVORITE')">      
      <v-favorite-selector-tab :query="request" :radio="radio" :fullscreen="fullscreen" :partner="partner" :selected="cxt.selected()" v-on:input="changeSelected" v-on:change="changeRequest" :methodsQueue="methodsQueue"></v-favorite-selector-tab>
    </div>
    <div v-if="sourceIs('SEARCH')">
      <v-search-selector-tab :query="request" :radio="radio" :fullscreen="fullscreen" :partner="partner" :selected="cxt.selected()" v-on:input="changeSelected" :methodsQueue="methodsQueue"></v-search-selector-tab>
    </div>
      <div v-if="sourceIs('LIST')">
      <v-list-selector-tab :query="request" :radio="radio" :fullscreen="fullscreen" :partner="partner" :selected="cxt.selected()" v-on:input="changeSelected" :methodsQueue="methodsQueue"></v-list-selector-tab>
    </div>
    <v-card-actions>
      <v-btn :disabled='cxt.selectedCount() === 0' @click="ok">ОК</v-btn>
      <v-spacer></v-spacer>
      <v-btn v-show="cxt.selectedCount() === 0 && !radio" @click="checkAll()">Выбрать все</v-btn>
      <v-btn v-show="cxt.selectedCount() > 0" @click="cxt.clear()">Очистить</v-btn>
      <span tabindex="0" v-on:focus="firstFocus()"></span>      
    </v-card-actions>
    </v-layout>    
  </v-card>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import classes from '../../api/classes'
  import formats from '../../api/formats'
  import vActionsBtn from '../common/ActionsBtn'
  import vFavoriteSelectorTab from './FavoriteSelectorTab.vue'
  import vSearchSelectorTab from './SearchSelectorTab.vue'
  import vListSelectorTab from './ListSelectorTab.vue'

  class SourceAction extends classes.Action {
    constructor (context, key, title, visibleFunc, runFunc) {
      super(context, title, visibleFunc, runFunc)
      this.key = key
    }
    run () {
      return this.runFunc(this)
    }
  }

  export default {
    name: 'client-selector',
    components: {vActionsBtn, vFavoriteSelectorTab, vSearchSelectorTab, vListSelectorTab},
    data: () => ({
      request: '',
      source: null,
      sources: [],
      cxt: null,
      radioItem: null,
      methodsQueue: []
    }),
    created () {
      let cxt = new classes.MultiSelectContext(() => {})
      cxt.mode = classes.modes.SELECT
      cxt.filterMode = true
      this.cxt = cxt
      this.sources = this.sourceActions()
      this.source = this.sources && this.sources.length > 0 ? this.sources[0] : null
      this.request = this.query
    },
    mounted () {
      this.sources = this.sourceActions()
      this.source = this.sources && this.sources.length > 0 ? this.sources[0] : null
      this.request = this.query
    },
    watch: {
      source: function (newVal, oldVal) {
        // if (newVal !== oldVal) {
          this.$el.focus()
          this.setFocus()
        // }
      }
    },
    props: {
      fullscreen: {
        type: Boolean,
        default: false
      },
      radio: {
        type: Boolean,
        default: false
      },
      partner: {
        type: Boolean,
        default: false
      },
      refCode: {
        type: Boolean,
        default: false
      },
      favorite: {
        type: Boolean,
        default: false
      },
      query: {
        type: String,
        default: null
      }
    },
    computed: {
      ...mapGetters({
        getIsMobile: 'getIsMobile',
        getProfileHaveClient: 'getProfileHaveClient'
      }),
      title () {
        return this.partner ? 'Выберите партнера' : 'Выберите компанию'
      },
      items () {
        return []
      }
    },
    methods: {
      setFocus () {
        this.$nextTick(function () {
          console.log('firstFocus', document.activeElement, this.$el.contains(document.activeElement))
          if (!this.$el.contains(document.activeElement)) {
            this.$el.focus()
          }
        })
      },
      firstFocus () {
        let input = this.$el.querySelector('input')
        console.log('firstFocus', input)
        if (input) {
          input.focus()
        } else {
          this.$el.focus()
        }
      },
      ok () {
        let result = []
        if (this.refCode) {
          this.cxt.selected().forEach(e => {
            if (e.split('_').length > 0) {
              result.push(e.split('_')[0])
            }
          })
          this.convertResult(result)
          .then(data => {
            this.$emit('input', data)
            this.cancel()
          })
        } else {
          this.cxt.selected().forEach(e => {
            if (e.split('_').length > 1) {
              result.push(e.split('_')[1])
            }
          })
          this.$emit('input', result)
          this.cancel()
        }
      },
      cancel () {
        this.$emit('close')
        this.item = null
      },
      convertResult (refCodes) {
        return new Promise((resolve, reject) => {
          let inns = refCodes.filter(r => !formats.isRefCode(r)).map(r => r.replace('inn:', ''))
          let result = refCodes.filter(r => formats.isRefCode(r))
          if (inns.length > 0) {
            this.$store.dispatch('convertInnToRefCode', {inns: inns})
              .then(map => resolve(result.concat(Object.values(map))))
          } else {
            resolve(result)
          }
        })
      },
      checkAll () {
        this.methodsQueue.push({name: 'checkAll', params: {}})
      },
      changeSelected (ids) {
        console.log('changeSelected', ids)
        this.cxt.setSelected(ids)
      },
      changeRequest (e) {
        this.request = e
      },
      sourceActionsCaption () {
        return this.source ? this.source.caption() : null
      },
      sourceIs (key) {
        return this.source && formats.compareString(this.source.key, key) === 0
      },
      getSourceAction (key) {
        return this.sources.find(o => formats.compareString(o.key, key) === 0)
      },
      sourceActions () {
        let result = []
        if (this.favorite && !this.partner) {
          result.push(new SourceAction(this, 'FAVORITE', 'Мои контрагенты', null, (self) => { this.source = self }))
        }
        result.push(new SourceAction(this, 'SEARCH', 'Поиск', null, (self) => { this.source = self }))
        if (!this.partner && !this.favorite && !this.radio) {
          result.push(new SourceAction(this, 'LIST', 'Список', null, (self) => { this.source = self }))
        }
        return result
      }
    }

  }

</script>




// WEBPACK FOOTER //
// ClientSelector.vue?629803d5